//src/components/SellPropertyUI.js
export const StepSection = ({ icon, title, desc, children }) => (
    <div>
        <h3 className="sell-section-title">
            {icon} {title}
        </h3>
        <p className="sell-section-desc">{desc}</p>
        <div className="sell-section-divider" />
        {children}
    </div>
);

export const FormField = ({ label, error, fullWidth, children }) => (
    <div className={`sell-field${fullWidth ? ' sell-field--full' : ''}`}>
        {label ? <div className="mp-label">{label}</div> : null}
        {children}
        {error && <span className="sell-field-error">{error}</span>}
    </div>
);

export const InputIcon = ({ children }) => <span className="sell-input-icon">{children}</span>;

export const SummarySection = ({ title, rows }) => (
    <div className="sell-summary-section">
        <h4 className="sell-summary-title">{title}</h4>
        <div className="sell-summary-rows">
            {rows
                .filter((r) => r.value && r.value !== '-')
                .map(({ label, value }) => (
                    <div key={label} className="sell-summary-row">
                        <span className="sell-summary-label">{label}</span>
                        <span className="sell-summary-value">{value}</span>
                    </div>
                ))}
        </div>
    </div>
);

export const ErrorAlert = ({ message }) =>
    message ? <div className="sell-alert sell-alert--error">{message}</div> : null;
